
import {createAction} from "redux-actions";

export const toggleActiveModal = createAction("TOGGLE_ACTIVE_MODAL");


// WEBPACK FOOTER //
// ./app/client/_widgets/modal/actions.ts